export var unreachable = function unreachable(t) {
  throw new Error("this was supposed to be unreachable ".concat(t));
};
export var unreachableWithReturn = function unreachableWithReturn(_, value) {
  return value;
};